<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch01_part02"><a id="page_25"></a><span class="small">TWO</span> 1900—1924<a id="page_26"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01_part02.vue?803dc926